// extracted by mini-css-extract-plugin
export default {"DividerStyle":"ItemProcessDetail_DividerStyle__aJiKs","FormCardItemStyle":"ItemProcessDetail_FormCardItemStyle__yt3xz","TagStyle":"ItemProcessDetail_TagStyle__4pexF"};